import { colors, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      overflow: "auto",
      height: "100vh",
      background: theme.palette.common.white,
    },
    navBar: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 1000,

      height: "calc(100vh - 102px)",
      width: 500,
      borderRight: "1px solid #e8e8e8",
      overflow: "hidden",
    },

    navBarMenuWrapper: {
      height: "calc(100vh - 102px)",
    },

    wrapperContent: {
      width: "100%",
      height: "calc(100vh - 102px)",
      overflow: "hidden",
      paddingLeft: 500,
    },

    myCard: {
      paddingTop: "30px",
      paddingLeft: "30px",
      marginLeft: 50,
      marginRight: 50,
    },

    wrapperContentInner: {},

    tabsPanel: {
      width: "100%",
      overflowX: "hidden",
      overflowY: "auto",
    },
    wrapper: {
      "& input": {
        padding: "13px 18px 17px 18px",
        fontSize: 16,
      },
    },

    caption: {
      color: colors.grey[600],
      fontWeight: 400,
    },

    leftHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "nowrap",
      
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.secondary.main,
    },

    leftWrapper: {
      overflow: "auto",
      height: "calc(100vh - 178px)",
      paddingBottom: theme.spacing(6),

      "& table": {
        fontSize: 14,

        "& thead tr th": {
          padding: theme.spacing(2),
        },

        "& tbody tr td": {
          padding: `10px ${theme.spacing(2)}px`,
        },

        "& thead tr th:first-child": {
          paddingLeft: theme.spacing(4),
        },

        "& thead tr th:last-child": {
          paddingRight: theme.spacing(4),
          textAlign: "right",
        },

        "& tbody tr td:first-child": {
          paddingLeft: theme.spacing(4),
        },

        "& tbody tr td:last-child": {
          paddingRight: theme.spacing(4),
          textAlign: "right",
        },
      },
    },

    blueCell: {
      color: theme.palette.info.main,
      fontWeight: theme.typography.fontWeightMedium,
    },

    link: {
      color: theme.palette.info.main,
    },

    trailing: {},

    gridItem: {
      // border: "1px solid red",
    },
    subButton: {
      textTransform: "none",
      fontSize: 10,
      padding: 2,
      margin: 2,
      width: 35,
    },
    searchGroup: {
      display: "inline-flex",
      width: "100%",
    },
    testField: {
      margin: 3,
      height: 40,
    },
    testField1: {
      height: 35,
      margin: 10,
      marginTop: 32,
    },
    searchAuto: {
      //border: '1px outset lightgray',
      display: "inline-block",
      marginTop: 2,
      marginLeft: 5,
      width: 170,
      height: 35,
    },
  }),

  {
    name: "countries-tab-styles",
    flip: null,
  }
);

export default useStyles;
